import { Action } from '@ngrx/store';

export class NotificationsAction implements Action {

    public static getNotifications: string = '[Notifications] get_notifications';
    public static getNotificationsError: string = '[Notifications] get_notifications_error';
    public static getNotificationsSuccess: string = '[Notifications] get_notifications_success';

    public static readNotification: string = '[Notifications] read_notification';
    public static readNotificationError: string = '[Notifications] read_notification_error';
    public static readNotificationSuccess: string = '[Notifications] read_notification_success';

    public static subscribeNotificationChannel: string = '[Notifications] subscribeNotificationChannel';
    public static subscribeNotificationChannelError: string = '[Notifications] subscribeNotificationChannel_error';
    public static subscribeNotificationChannelSuccess: string = '[Notifications] subscribeNotificationChannel_success';

    public static unsubscribeNotificationChannel: string = '[Notifications] unsubscribeNotificationChannel';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
